<template>
  <div class="modal-container" ref="modalContainer">
    <div class="form-content-body" >
      <div>
        <div class="row">

          <div
              class="col-md-12 text-center modal-header px-4 align-items-center"
          >
            <div class="header-container row w-100 py-3">
              <h3 class="col-10 text-left ml-3 section-title">
                <span>Preview questionnaire: {{ caseNumber.toUpperCase() }}</span>
              </h3>
              <button class="close close-btn text-right col-1" @click="$emit('close')">
                <img src="../assets/images/icon-close.svg" />
              </button>
            </div>
          </div>
        </div>
        <div class="row no-gutters preview-details-container">
          <div class="overlay-loader-container w-100 text-center pt-5" v-if="isPreviewDataLoading">
            <img class="overlay-loader loading-spinner" :src="CONSTANTS.SPINNER_URL" alt="Loading Spinner">
          </div>

          <div class="col-12" v-else>
            <div class="alert-container mb-2" v-if="errorMessage">
              <div class="fade-in-out alert alert-error" >
                <div><strong>{{errorMessage}}</strong></div>
              </div>
            </div>

            <div class="row no-gutters mb-2 pt-3">
              <div class="col-12" :class="dataExists? 'px-5':'pl-4'">
                <span class="back-btn" @click="routeToStatusModal">
                  <font-awesome-icon icon="arrow-left" size="sm"/>
                    Back to case status
                </span>
              </div>
            </div>

            <div class="px-5 pb-5 row no-gutters" v-if="!isPreviewDataLoading && !errorMessage && dataExists">
              <div v-for="(data, index) in filteredPreviewData" :key="index" class="col-6 my-3 px-2">
                <div class="preview-question">
                  {{data.questionText}}
                </div>
                <!--  Show plain text value in case its not user clickable link   -->
                <div class="preview-value" v-if="!isRequestedForField(data) && !isWatchersField(data)">
                  {{ data.value | naIfEmpty | booleanToYesNo }}
                </div>
                <!--  Show user clickable link for requested for (Id received from servicenow)   -->
                <div class="preview-value" v-else-if="isRequestedForField(data) && !isWatchersField(data)">
                  <span v-if="userData(data.value) && userData(data.value).userId">
                    <user-full-name :user-detail="userData(data.value)" />
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
                <!--  Show user clickable link for watchers for (ID fetched from servicenow)   -->
                <div class="preview-value" v-else-if="!isRequestedForField(data) && isWatchersField(data)">
                  <span v-if="data.value.length > 0">
                    <span v-for="(user, userIndex) in data.value" :key="userIndex">
                      <!-- show comma in case two users. Example: Watchers - User1, User2  -->
                      <span v-if="userIndex > 0 && userIndex < data.value.length">, </span>
                      <a v-if="user.isEmployeeHubLink" :href="userProfileUrl(user)" target="_blank" class="solution-link">{{user.fullName}}</a>
                      <span v-else>{{user.fullName}}</span>
                    </span>
                  </span>
                  <span v-else>
                    N/A
                  </span>
                </div>
              </div>
            </div>
            <div v-else-if="!isPreviewDataLoading && !errorMessage && !dataExists">
              <div class="p-4 font-weight-bold">
                No data exists for {{caseNumber}}.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row buttons-group no-gutters justify-content-end pb-4 px-md-0 px-3 ml-md-0 ml-3">
        <button :disabled="isPreviewDataLoading" class="btn-container flat-btn gray-btn close-btn btn mx-3" @click="$emit('close')">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import questionnaireMap from "@/store/questionnaireMap";
import CONSTANTS from "@/store/constants";
import UserFullName from "@/components/UserFullName";
import { mapGetters } from "vuex"
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";

export default {
  name: "QuestionnairePreviewModal",
  props: ["caseNumber","exitPoint"],
  components: {UserFullName},
  computed: {
    ...mapGetters(['userData']),
    filteredPreviewData() {
      if(this.exitPoint.toLowerCase() === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT.toLowerCase()) {
        return this.getFilteredPreviewData()
      } else
      return this.previewData
    }
  },
  data() {
    return {
      previewData: [],
      isPreviewDataLoading: false,
      errorMessage: '',
      dataExists: true,
      requestedForQuestion: 'Requested for',
      watchersQuestion: 'Watchers',
      needHelpWithSupplierQuestion: '',
      PARENT_QUESTION: "1. Request type",
      conditionalQuestions: [
        {
          questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.SPONSORSHIP_TEXT,
          showWhenRequestTypeIs: [EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.SPONSORSHIP]
        },
        {
          questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.CORPORATE_DONATION_TEXT,
          showWhenRequestTypeIs: [EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.CORPORATE_DONATION]
        },
        {
          questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.SPEAKER_TEXT,
          showWhenRequestTypeIs: [EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.SPEAKER]
        },
        {
          questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.OTHER_TEXT,
          showWhenRequestTypeIs: [EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.OTHER]
        },
        {
          questionText: "1. a "+EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_CHECKBOX_TEXT.GENERIC_CHECKBOX_TEXT,
          showWhenRequestTypeIs: [EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.ADSK_CONSULTING_ENGAGEMENTS,
            EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.LEGAL_SERVICES,
            EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP.RENT_UTILITIES]
        }


      ],
    }
  },
  mounted() {
    this.filterSupplierQuestion()
    this.initializeData()
  },
  filters: {
    naIfEmpty: function (value) {
      return value ? value : "N/A";
    },
    booleanToYesNo: function(value) {
      if(value === 'true' || value === true || value === 'yes')
        return 'Yes'
      else if(value === 'false' || value === false || value === 'no')
        return 'No'
      else return value
    }
  },
  methods: {
    /*
    * Need help with supplier question is Q 7 in exception submission and Q 8 in one-intake.
    */
    filterSupplierQuestion() {
      if(this.exitPoint && this.exitPoint.toLowerCase() === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT.toLowerCase())
        this.needHelpWithSupplierQuestion = '7. Have you selected a supplier?'
      else
        this.needHelpWithSupplierQuestion = '8. Have you selected a supplier?'
    },
    getFilteredPreviewData() {
      let filteredPreviewData = []
      let parentAnswer = this.previewData.find(ht => ht.questionText === this.PARENT_QUESTION)
      this.previewData.forEach(data => {
        let conditionalAnswer = this.conditionalQuestions.find(value => value.questionText.toLowerCase() === data.questionText.toLowerCase())
        if(conditionalAnswer) {
          if(conditionalAnswer.showWhenRequestTypeIs.some(request => request.toLowerCase() === parentAnswer.value.toLowerCase())) {
            filteredPreviewData.push(data)
          }
        } else {
          filteredPreviewData.push(data)
        }
      })
      return filteredPreviewData
    },
    userProfileUrl(userDetail) {
      return CONSTANTS.EH_URL + "/profile/"+userDetail.userId;
    },
    routeToStatusModal() {
      this.$parent.$emit('onRouteToStatusModal', this.caseNumber)
    },
    isRequestedForField(data) {
      return data.questionText.toLowerCase().includes(this.requestedForQuestion.toLowerCase())
    },
    isWatchersField(data) {
      return data.questionText.toLowerCase().includes(this.watchersQuestion.toLowerCase())
    },
    async getUserIds(userSysIds) {
      let filteredUserIds = []
      let userData = []
      let userSysIdsArray = userSysIds.split(',')
      userSysIdsArray.forEach((id) => {
        if(!id.includes(CONSTANTS.EMAIL_CHARACTER)) {
          filteredUserIds.push(id)
        } else {
          userData.push({
            fullName: id,
            userId: id,
            isEmployeeHubLink: false
          })
        }
      })
      try {
        const response = await api.getServiceNowUsers(filteredUserIds)
        if(response && response.data && response.data.result && response.data.result.length > 0) {
          response.data.result.forEach((user) => {
            userData.push({
              fullName: user.u_display_name,
              userId: user.user_name,
              isEmployeeHubLink: true
            })
          })
        }
      } catch {
        /* adding a silent fail for catch and not erroring out on watchers. */
      }
      return userData
    },
    async initializeData() {
      try {
        this.isPreviewDataLoading = true
        const response = await api.getQuestionnaireData(this.caseNumber, this.exitPoint)
        if(response && response.data && response.data.result && response.data.result.length > 0) {
          let questionnaireObj = response.data.result[0]
          //EXPAPORTAL-72 changes to not display Product Name if it generated by backend using supplier Name
          questionnaireObj.u_product_name = questionnaireObj.u_service_product === "true" ? "" : questionnaireObj.u_product_name;
          questionnaireObj.u_exception_corp_card_payment = questionnaireObj.u_exception_corp_card_payment ? questionnaireObj.u_exception_corp_card_payment : "";
          let fields = this.exitPoint.toLowerCase() === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT.toLowerCase() ?
              questionnaireMap.EXCEPTION_SUBMISSION_REQUEST_FIELDS : questionnaireMap.ONE_INTAKE_FIELDS
          for(const value of Object.values(fields)) {
            if(value.questionText === this.watchersQuestion && questionnaireObj[value.fieldName]) {
              let userIdList = await this.getUserIds(questionnaireObj[value.fieldName])
              this.previewData.push({
                questionText: value.questionText,
                value: userIdList
              })
            } else if(value.questionText === this.needHelpWithSupplierQuestion) {
              /*
              * Question 8: Have you selected a supplier? is saved in the service now as an opposite boolean of what is asked.
              * Need to reverse the service now value to show data accurately.
              */
              this.previewData.push({
                questionText: value.questionText,
                value: questionnaireObj[value.fieldName] && questionnaireObj[value.fieldName] === 'true' ? 'No' : 'Yes'
              })
            }else {
              this.previewData.push({
                questionText: value.questionText,
                value: questionnaireObj[value.fieldName]
              })
            }
          }
        } else {
          this.dataExists = false
        }
      } catch(error) {
        this.errorMessage = CONSTANTS.ERROR_MESSAGE
      } finally {
        this.isPreviewDataLoading = false
        let subEvent = `caseNumber - ${this.caseNumber}`
        this.$hhMixpanel.trackEvent('Supplier Central - Preview questionnaire', { subEvent : subEvent });
      }
    }
  }
}
</script>

<style scoped>
.preview-details-container {
  height: 70vh;
  overflow-y: auto;
}

.modal-header {
  height: 100%;
}

.preview-question {
  font-family: artifaktElementBold;
}
</style>